<template>
  <app-logged>
    <v-flex
      xs12
    >
      <app-pendencias />
    </v-flex>
  </app-logged>
</template>
<script>
import AppLogged from '@/components/layouts/AppLogged'
import AppPendencias from '@/components/AppPendencias'
export default {
  components: {
    AppLogged,
    AppPendencias
  }
}
</script>
